import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page3[0]",
	solicitorName: 'topmostSubform[0].Page3[0].NOTARY_NAME[0]',
	signatureDate: 'topmostSubform[0].Page3[0].DATE_SIGNATURE[0]',
	idExpiryDate2: 'topmostSubform[0].Page3[0].AUTRE_DATE_EXPIRATION_2[0]',
	idJurisdiction2: 'topmostSubform[0].Page3[0].AUTRE_TERRITOIRE_2[0]',
	countryOfIssue2: 'topmostSubform[0].Page3[0].AUTRE_PAYS_2[0]',
	idNumber2: 'topmostSubform[0].Page3[0].AUTRE_NUMERO_2[0]',
	idType2: 'topmostSubform[0].Page3[0].AUTRE_TYPE_2[0]',
	idExpiryDate: 'topmostSubform[0].Page3[0].AUTRE_DATE_EXPIRATION_1[0]',
	idJurisdiction: 'topmostSubform[0].Page3[0].AUTRE_TERRITOIRE_1[0]',
	countryOfIssue: 'topmostSubform[0].Page3[0].AUTRE_PAYS_1[0]',
	idNumber: 'topmostSubform[0].Page3[0].AUTRE_NUMERO_1[0]',
	idType: 'topmostSubform[0].Page3[0].AUTRE_TYPE_1[0]',
	dateOfBirth: 'topmostSubform[0].Page3[0].AUTRE_DATE_NAISSANCE_1[0]',
	mortgagorFullName: 'topmostSubform[0].Page3[0].AUTRE_NOM_1[0]',
	description2: 'topmostSubform[0].Page3[0].SOCIETE_DESCRIPTION_2[0]',
	electronicVersion2: 'topmostSubform[0].Page3[0].SOCIETE_SOURCE_REGISTRE_2[0]',
	typeOfRecord2: 'topmostSubform[0].Page3[0].SOCIETE_TYPE_REGISTRE_2[0]',
	registrationNumber2: 'topmostSubform[0].Page3[0].SOCIETE_NUMERO_2[0]',
	typeOfEntity2: 'topmostSubform[0].Page3[0].SOCIETE_TYPE_2[0]',
	corporationName2: 'topmostSubform[0].Page3[0].NOM_SOCIETE_2[0]',
	// "22":"topmostSubform[0].Page2[0]",
	description: 'topmostSubform[0].Page2[0].SOCIETE_DESCRIPTION_1[0]',
	electronicVersion: 'topmostSubform[0].Page2[0].SOCIETE_SOURCE_REGISTRE_1[0]',
	typeOfRecord: 'topmostSubform[0].Page2[0].SOCIETE_TYPE_REGISTRE_1[0]',
	registrationNumber: 'topmostSubform[0].Page2[0].SOCIETE_NUMERO_1[0]',
	typeOfEntity: 'topmostSubform[0].Page2[0].SOCIETE_TYPE_1[0]',
	corporationName: 'topmostSubform[0].Page2[0].NOM_SOCIETE_1[0]',
	country3: 'topmostSubform[0].Page2[0].PAYS_3[0]',
	jurisdiction3: 'topmostSubform[0].Page2[0].TERRITOIRE_3[0]',
	expiryDate3: 'topmostSubform[0].Page2[0].DATE_EXPIRATION_3[0]',
	number3: 'topmostSubform[0].Page2[0].NUMERO_3[0]',
	type3: 'topmostSubform[0].Page2[0].TYPE_3[0]',
	mortgagor3: 'topmostSubform[0].Page2[0].NOM_COMPLET_3[0]',
	country2: 'topmostSubform[0].Page2[0].PAYS_2[0]',
	jurisdiction2: 'topmostSubform[0].Page2[0].TERRITOIRE_2[0]',
	expiryDate2: 'topmostSubform[0].Page2[0].DATE_EXPIRATION_2[0]',
	number2: 'topmostSubform[0].Page2[0].NUMERO_2[0]',
	type2: 'topmostSubform[0].Page2[0].TYPE_2[0]',
	mortgagor2: 'topmostSubform[0].Page2[0].NOM_COMPLET_2[0]',
	countryA: 'topmostSubform[0].Page2[0].PAYS_1[0]',
	jurisdictionA: 'topmostSubform[0].Page2[0].TERRITOIRE_1[0]',
	expiryDateA: 'topmostSubform[0].Page2[0].DATE_EXPIRATION_1[0]',
	numberA: 'topmostSubform[0].Page2[0].NUMERO_1[0]',
	typeA: 'topmostSubform[0].Page2[0].TYPE_1[0]',
	mortgagor1: 'topmostSubform[0].Page2[0].NOM_COMPLET_1[0]',
	propertyAddress: 'topmostSubform[0].Page2[0].ADR_PROP1_RUE[0]',
	mortgageLoanNumber: 'topmostSubform[0].Page2[0].ID_PRET_CLIENT[0]',
	// "49":"topmostSubform[0].Page2[0].BARCODE_FAX_RETURN_LENDER[0]"
};

export interface CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION {
	mortgageLoanNumber: string;
	propertyAddress: string;

	mortgagor1: string;

	typeA: string;
	numberA: string;
	expiryDateA: string;
	jurisdictionA: string;
	countryA: string;

	mortgagor2: string;

	type2: string;
	number2: string;
	expiryDate2: string;
	jurisdiction2: string;
	country2: string;

	mortgagor3: string;

	type3: string;
	number3: string;
	expiryDate3: string;
	jurisdiction3: string;
	country3: string;

	corporationName: string;
	typeOfEntity: string;
	registrationNumber: string;
	typeOfRecord: string;
	electronicVersion: string;
	description: string;

	corporationName2: string;
	typeOfEntity2: string;
	registrationNumber2: string;
	typeOfRecord2: string;
	electronicVersion2: string;
	description2: string;

	mortgagorFullName: string;
	dateOfBirth: string;

	idType: string;
	idNumber: string;
	countryOfIssue: string;
	idJurisdiction: string;
	idExpiryDate: string;

	idType2: string;
	idNumber2: string;
	countryOfIssue2: string;
	idJurisdiction2: string;
	idExpiryDate2: string;

	signatureDate: string;
	solicitorName: string;
}
